import { useInfiniteQuery } from "@tanstack/react-query";
import API from "@/api";

function useRackObservations(nurseryId: string, rackId: string) {
  const { data, error, fetchNextPage, hasNextPage, isFetching, isFetchingNextPage, } = useInfiniteQuery({
    queryKey: ["rack-observations", nurseryId, rackId],
    queryFn: ({ pageParam }) => API.getRackObservations(nurseryId, rackId, pageParam),
    initialPageParam: 1,
    getNextPageParam: (lastPage) => {
      if (lastPage.next) {
        const link = URL.parse(lastPage.next);
        return link ? Number(link.searchParams.get("page")) : null;
      }
    }
  });

  return {
    fetchNextPage,
    hasNextPage,
    isFetching,
    isFetchingNextPage,
    error,
    data
  };
}

export default useRackObservations;
